import styled from 'styled-components';

export const TopButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;

  button {
    margin-right: 20px;
  }

  .MuiFormGroup-root {
    flex-direction: row;
    margin-right: 10px;

    label {
      padding-right: 15px;
    }
  }

  .SingleSelect {
    width: 180px;
    margin-right: 30px;
  }
`;
